import { hasSessionCookieAction, setSessionAction } from '@/lib/auth/session.actions';

/**
 * Sets the HttpOnly session cookie and confirms the browser stored it.
 * Navigation must not proceed unless this returns true — otherwise
 * middleware/SSR bounce login ↔ shop forever.
 */
export const setSessionCookieWithConfirmation = async (
    sessionToken: string,
): Promise<boolean> => {
    try {
        await setSessionAction(sessionToken);
        return await hasSessionCookieAction();
    } catch {
        return false;
    }
};
